export const CERTIFICADOPUSH = 'BNKtrf3eRrCrZJUZAquObtR6_Kt8oSdNcNS_L1JNbpO377l_duwwSgpi6gr2YHf6TH_upRkEgFh25DnpeC1ZMwQ'

export const URLAPI = 'https://restauranteslamerced.com/noti/firebasepush.php'

export const IDPROYECTO = 'restauranteslamerced-4c552'